<template>
  <v-autocomplete
    clearable
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :disabled="loading"
    :items="items"
    item-text="name"
    item-value="id"
    :label="label"
    class="ma-0"
  >
    <template v-slot:item="item">
      <div :data-test-schema="item.item.name">
        {{ item.item.name }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import objectsSchema from '@/api/objects/schemas.graphql';
import { onMounted, ref } from '@vue/composition-api';

export default {
  name: 'SearchObject',
  props: {
    first: {
      type: Number,
      default: 20
    },
    label: {
      type: String,
      default: 'Name'
    },
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const search = ref('');

    const lazyQuery = useLazyQuery(
      objectsSchema.listObjects,
      {
        filter: {
          ...props.filter,
          name: {
            includesInsensitive: search.value
          }
        },
        first: props.first
      },
      {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only'
      }
    );

    const items = useResult(lazyQuery.result, [], data => {
      return data.objects;
    });

    onMounted(() => {
      lazyQuery.load();
    });

    return {
      items,
      loading: lazyQuery.loading
    };
  }
};
</script>
